import withTooltip from "@components/hocs/withToolTip";

import CustomChip from "./CustomChip";

const CustomChipWithTooltip = withTooltip(CustomChip);

export default CustomChipWithTooltip;
